export default class Maps {
    
    constructor(mapConfig){
        this.map = {};
        this.config = mapConfig;
     //   this.infowindow = new google.maps.InfoWindow();
        this.markers = [];
        
        this.globalConfig = {
            zoom:12,
            zoomControl: true,
            scaleControl: false,
            center: new google.maps.LatLng(50.849454, 20.842628),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            scrollwheel: false
        }
        
        this.global = this.config.globalConfig || this.globalConfig;
        
        this.init();
        
    }
    

    
    /* @param LatLng - googlemaps coordinates ex. (40.222, 20.222) */
    createLatLng(coords) {
        return new google.maps.LatLng(parseFloat(coords.y), parseFloat(coords.x));
    };
    
    showMarkers() {
        for (let j = 0; j < this.config.locations.length; j++) {
            
            let marker = new google.maps.Marker({
                position: this.createLatLng( this.config.locations[j].coords),
                map: this.map,
                icon: {
                    url:  this.config.locations[j].marker,
                    anchor: new google.maps.Point(parseFloat(this.config.locations[j].anchor.x),parseFloat(this.config.locations[j].anchor.y))
                }
            });
            
            this.markers.push(marker);
            marker.addListener('click', function() {
                if (this.config.locations[j].main !== 1){
                    this.setInfoWindow(marker, this.config.locations[j].name);
                }
            });
        }
        
        this.hideMarkers();
    };
    
    setInfoWindow(marker, name){
        console.log(name);
        
        let contentString = '<div id="content">'+
            '<div id="bodyContent">'+
            '<p>'+ name +'</p>'+
            '</div>'+
            '</div>';
        
        this.infowindow.setContent(contentString);
        this.infowindow.open(this.map, marker);
    };
    
    setMapOnAll(map) {
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(map);
        }
    };
    
    showMarker(id) {
        if (id === undefined || id === null) {
            this.setMapOnAll(this.map);
            this.map.panTo(this.global.center);
        } else {
            this.markers[id].setMap(this.map);
            let location = this.config.locations[id];
            
            location.hasOwnProperty('offsetMove') ? this.moveToCoords(location.offsetMove) : this.moveToCoords(location.coords);
        }
    };
    
    moveToCoords(location) {
        this.map.panTo(this.createLatLng(location));
    };
    
    setPolygons() {
        let polygons = locations.polygons;
        
        polygons.map((data) => {
            this.showPolygon(data);
        });
    };
    
    showPolygon(polygon){
        let polygonsStyle =  polygon.style;
        polygonsStyle.paths = polygon.paths;
        
        let shape = new google.maps.Polygon(polygonsStyle);
        
        //console.log(polygonsStyle);
        shape.setMap(this.map);
    };
    
    hideMarkers(hideId) {
        this.setMapOnAll(null);
        this.showMarker(hideId);
        
    };
    
    init() {
        
        this.map = new google.maps.Map(document.getElementById(this.config.selector), this.global);
     //   this.config.locations.polygons ? this.setPolygons() : null;
     //   this.showMarkers();
    };

}


// WEBPACK FOOTER //
// ./components/core/core__Maps/Maps.js